import { useCallback, useMemo } from 'react'

import { NestedDropdown, NestedDropdownItem } from '@swaggerhub-portal/component-library'
import { useFetcher, useRouteLoaderData } from 'react-router'

import { useEnvironment } from '~/hooks/useEnvironment'
import { ACTION } from '~/services/actions'
import { AppLoaderData, Environment } from '~/types/app'
import { FeatureFlags } from '~/types/flags'

export const DebugUI = () => {
  const env = useEnvironment()

  const isProd = env === Environment.PROD
  const isLocal = env === Environment.LOCAL
  const isDev = env === Environment.DEV

  const fetcher = useFetcher()

  const { flags: rootFlags, appToken } = useRouteLoaderData<AppLoaderData>('root') || { flags: {}, appToken: '' }

  if (isProd) {
    return null
  }

  const flags = useCallback(() => Object.values(FeatureFlags).map((value) => {
    if (rootFlags[value] === true) {
      return <span className="cursor-pointer px-4 py-1.5" key={value} onClick={() => {
        fetcher?.submit?.({}, { method: 'POST', action: ACTION.TOGGLE_FEATURE_FLAG({ [value]: false }) })
      }}>{value} &#x2713;</span>
    }

    return <span className="cursor-pointer px-4 py-1.5" key={value} onClick={() => {
      fetcher?.submit?.({}, { method: 'POST', action: ACTION.TOGGLE_FEATURE_FLAG({ [value]: true }) })
    }}>{value}</span>

  }), [rootFlags])

  const menuItems: NestedDropdownItem[] = useMemo(() => {
    const items = [{
      name: 'Enabled Flags',
      options: flags() as any,
    }]

    items.push({
      name: 'Tools',
      options: [
        (isLocal || isDev) && 'Storybook',
        !isLocal && 'Copy APP Token',
      ],
    },
    {
      name: 'Reset Values',
      options: ['Reset Welcome Modal', 'Reset Pre Setup'],
    })

    return items
  }, [rootFlags])

  const handleDebugOption = useCallback((e) => {
    switch (e) {
      case 'Storybook':
        window.location.href = '/storybook'
        break
      case 'Reset Welcome Modal':
        fetcher?.submit?.({}, { method: 'POST', action: ACTION.SET_WELCOME_MODAL({ showModal: true }) })
        location.reload()
        break
      case 'Reset Pre Setup':
        fetcher?.submit?.({}, { method: 'POST', action: ACTION.SET_REDIRECT_TO_PRESETUP({ redirect: true }) })
        location.reload()
        break
      case 'Copy APP Token':
        try {
          navigator.clipboard.writeText(String(appToken))
          window.alert('App token copied to clipboard')
        } catch {
          // do nothing
        }
        break
      default:
        break
    }
  }, [rootFlags])

  return (
    <div className="mr-4">
      <NestedDropdown
        dropdownButton="Debug"
        menuItems={menuItems}
        onClick={handleDebugOption}
      />
    </div>
  )
}